import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { compose } from 'redux';
import { IconStar } from '@americanexpress/dls-icons';
import isDeepEqual from '../../utils/isDeepEqual';
import styles from '../Suggestions/Suggestions.scss';
import CategoryList from '../Suggestions/CategoryList';
import {
  isLocationDefined,
  mapIntlPopularLocationsToLocationShape,
  isValidDirection,
  isSupportedVersion,
  filterValidLocations,
} from '../../utils/popularLocationsUtils';
import { locationShape } from '../../shape/locationShape';
import withOneCmsJson from '../../hocs/withOneCmsJson';
import getPopularLocationsOneCmsUrlSelector from '../../selectors/getPopularLocationsOneCmsUrl';
import locationContext from '../../context/locationsContext';

const PopularLocations = ({
  allPopularLocations,
  query,
  upstreamLocation,
  isOneCmsLoading,
  hasOneCmsLoadErrors,
  popupHeader,
  isEnabled,
  jsonVersion,
}) => {
  const {
    state: {
      locationsShown,
    },
    actions: {
      updateShownLocations,
    },
  } = React.useContext(locationContext);

  if (hasOneCmsLoadErrors
    || isOneCmsLoading
    || !isEnabled
    || !isSupportedVersion(jsonVersion)
    || !!query
    || !allPopularLocations || allPopularLocations.length === 0
    || isLocationDefined(upstreamLocation)) {
    return null;
  }

  const validLocations = filterValidLocations(allPopularLocations);
  const mappedLocations = mapIntlPopularLocationsToLocationShape(validLocations);

  // todo: refactor this. Can't have setState on render body
  if (!isDeepEqual(locationsShown, mappedLocations)) {
    updateShownLocations(mappedLocations);
  }

  return (
    <div
      id="popularLocationsListbox"
      className={clsx(styles.suggestionsWrapper,
        'position-absolute border color-border-subtle color-surface-bg radius-container-sm shadow-3 pad-1 margin-1')}
      role="listbox"
      aria-live="polite"
    >
      <CategoryList
        suggestions={mappedLocations}
        headerText={popupHeader}
        iconNode={IconStar}
        categoryKey="POPULAR"
        categoryIndex={0}
        categoryOffset={0}
        indexIncrement={0}
      />
    </div>
  );
};

PopularLocations.propTypes = {
  allPopularLocations: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
  })),
  query: PropTypes.string.isRequired,
  popupHeader: PropTypes.string.isRequired,
  upstreamLocation: PropTypes.shape(locationShape).isRequired,
  isOneCmsLoading: PropTypes.bool.isRequired,
  hasOneCmsLoadErrors: PropTypes.bool.isRequired,
  isEnabled: PropTypes.bool.isRequired,
  jsonVersion: PropTypes.number.isRequired,
};

PopularLocations.defaultProps = {
  allPopularLocations: [],
};

export const mapOneCmsJsonToProps = (state, { type, direction }) => {
  if (isValidDirection(direction)) {
    return {
      popupHeader: `${type}.${direction}.header`,
      allPopularLocations: `${type}.${direction}.locations`,
      isEnabled: `${type}.${direction}.isEnabled`,
      jsonVersion: 'version',
    };
  }
  return {};
};

const hocChain = compose(
  withOneCmsJson(getPopularLocationsOneCmsUrlSelector, mapOneCmsJsonToProps)
);

export { PopularLocations as TestablePopularLocations };
export default hocChain(PopularLocations);
